module.exports = __webpack_public_path__ + "static/media/face_toxic.1e96cfa7.svg";